import {getAuth, onAuthStateChanged} from "firebase/auth";
import "../firebaseConfig/firebaseConfig";

function _FunctionHandler() {
    let backendLink = 'https://app-umouh6skwq-lz.a.run.app';
    // let backendLink = 'http://localhost:5001/diwi-print/europe-north1/app';

    let user = null;

    onAuthStateChanged(getAuth(), (userObj) => {
        user = userObj;
    });


    this.sendData = async function sendData(url, payload, callback) {
        const headers = {
            'Content-Type': 'application/json'
        }

        if (user) {
            headers.Authorization = `Bearer ${await user.getIdToken()}`;
        }

        fetch(backendLink + url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({...payload})
        }).then((response) => {
            if (response.status === 500) {
                throw new Error('Error handling the request');
            }

            response.json().then(data => {
                if (callback) {
                    callback(data);
                }
            })
        }).catch((err) => {
            callback(err.message, true, err);
        });
    };

    this.sendFile = async function sendFile(url, file, callback) {
        fetch(backendLink + url, {
            method: 'POST',
            body: file
        }).then((response) => response.json().then(data => {
            if (callback) {
                callback(data);
            }
        })).catch((err) => {
            callback(err.message, true, err);
        });
    };

    this.getData = async function getData(url, callback) {
        const headers = {
            'Content-Type': 'application/json'
        }

        if (user) {
            headers.Authorization = `Bearer ${await user.getIdToken()}`;
        }

        fetch(backendLink + url, {
            method: 'GET',
            headers: headers
        }).then((response) => response.json().then(data => {
            if (callback) {
                callback(data);
            }
        })).catch((err) => {
            callback(err.message, true, err);
        });
    };

    this.getFunctionUrl = function getFunctionUrl(url) {
        return backendLink + url;
    };
}

const FunctionHandler = new _FunctionHandler();
export default FunctionHandler;
